export const daysToMinutes = (days) => days * 24 * 60;
